/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRechercheApprenantViewDto } from './FcbRechercheApprenantViewDto';
import {
    FcbRechercheApprenantViewDtoFromJSON,
    FcbRechercheApprenantViewDtoFromJSONTyped,
    FcbRechercheApprenantViewDtoToJSON,
} from './FcbRechercheApprenantViewDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRechercheApprenantViewDtoPaginatedResults
 */
export interface FcbRechercheApprenantViewDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRechercheApprenantViewDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRechercheApprenantViewDto>}
     * @memberof FcbRechercheApprenantViewDtoPaginatedResults
     */
    results?: Array<FcbRechercheApprenantViewDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRechercheApprenantViewDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRechercheApprenantViewDtoPaginatedResults interface.
 */
export function instanceOfFcbRechercheApprenantViewDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRechercheApprenantViewDtoPaginatedResultsFromJSON(json: any): FcbRechercheApprenantViewDtoPaginatedResults {
    return FcbRechercheApprenantViewDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRechercheApprenantViewDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRechercheApprenantViewDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRechercheApprenantViewDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRechercheApprenantViewDtoPaginatedResultsToJSON(value?: FcbRechercheApprenantViewDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRechercheApprenantViewDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

